var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isVisible)?_c(_setup.XBtn,{attrs:{"color":_setup.btnColor,"icon":"mdi-help-circle"},on:{"click":function($event){$event.stopPropagation();return (() => _setup.openHelpDialog()).apply(null, arguments)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }